import findIndex from 'lodash/findIndex';
import every from 'lodash/every';

const initialState = {
  loading: false,
  availablePaymentCadences: null,
  errorAvailablePaymentCadences: null,
  selectedCadence: null,
  saveButtonEnabled: false,
  userEditable: false,
  showModal: false,
  updateSelectedCadenceLoading: false,
  errorUpdateSelectedCadence: null,
};

const withoutDailyCadence = (availableCadences) => {
  return availableCadences.filter((cadence) => cadence.duration !== 1);
};

const findSelectedCadence = (availableCadences, selectedCadence = null) => {
  if (selectedCadence == null) {
    return findIndex(withoutDailyCadence(availableCadences), {
      active: true,
    });
  }
  return selectedCadence;
};

const isUserEditable = (availableCadences) => {
  return every(withoutDailyCadence(availableCadences), {
    editable: 'user_editable',
  });
};

const paymentsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case 'GET_AVAILABLE_PAYMENT_CADENCES_REQUEST': {
      return {
        ...state,
        loading: true,
      };
    }
    case 'GET_AVAILABLE_PAYMENT_CADENCES_SUCCESS': {
      return {
        ...state,
        loading: false,
        availablePaymentCadences: withoutDailyCadence(
          action.payload.available_cadences,
        ),
        selectedCadence: findSelectedCadence(
          action.payload.available_cadences,
          state.selectedCadence,
        ),
        userEditable: isUserEditable(action.payload.available_cadences),
        nextPayoutEndDate: new Date(action.payload.current_payout.end_date),
      };
    }
    case 'GET_AVAILABLE_PAYMENT_CADENCES_FAILURE': {
      return {
        ...state,
        loading: false,
        errorAvailablePaymentCadences: action.payload,
      };
    }
    case 'SET_SELECTED_CADENCE': {
      return {
        ...state,
        selectedCadence: action.selected_cadence,
        saveButtonEnabled: !state.availablePaymentCadences[
          action.selected_cadence
        ].active,
      };
    }
    case 'DISPLAY_MODAL': {
      return {
        ...state,
        showModal: true,
        errorUpdateSelectedCadence: null,
      };
    }
    case 'HIDE_MODAL': {
      return {
        ...state,
        showModal: false,
      };
    }
    case 'UPDATE_PAYMENT_CADENCE_REQUEST': {
      return {
        ...state,
        updateSelectedCadenceLoading: true,
      };
    }
    case 'UPDATE_PAYMENT_CADENCE_SUCCESS': {
      return {
        ...state,
        loading: false,
        saveButtonEnabled: false,
        showModal: false,
        errorAvailablePaymentCadences: null,
        errorUpdateSelectedCadence: null,
        updateSelectedCadenceLoading: false,
        availablePaymentCadences: withoutDailyCadence(
          action.payload.available_cadences,
        ),
        selectedCadence: findSelectedCadence(action.payload.available_cadences),
        userEditable: isUserEditable(action.payload.available_cadences),
      };
    }
    case 'UPDATE_PAYMENT_CADENCE_FAILURE': {
      return {
        ...state,
        updateSelectedCadenceLoading: false,
        errorUpdateSelectedCadence: action.payload,
      };
    }
    default:
      return state;
  }
};

export default paymentsReducer;
